import script from "./customDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./customDropdown.vue?vue&type=script&setup=true&lang=js"

import "./customDropdown.vue?vue&type=style&index=0&id=706da99d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706da99d"]])

export default __exports__